var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoralLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "coral_logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363.072 47.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dental",
    transform: "translate(-60.636 134.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(166.955 -116.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M19.5,0V18.161c0,6.59-2.177,8.818-8.621,8.818H-5.153V22.359H10.177c3.9,0,5.085-1.175,5.085-5.029V4.585H-5.122V0Z",
    transform: "translate(5.153)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M117.475-124.505H88.638v-4.415h28.838Z",
    transform: "translate(105.958 22.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M121.126-126.519H95.48v-4.553h25.646Z",
    transform: "translate(131.848 14.538)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(227.054 -107.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M20.679,0c-.461,13.144-7.52,18.6-24.242,18.733v-4.56C8.2,14.1,14.339,11.115,15.7,4.8l.083-.385H-5.465V0Z",
    transform: "translate(5.465)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(265.383 -116.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M3.259,0V22.728l.422-.159c5.532-2.051,8.028-7.647,8.076-18.082h3.968C15.65,19.645,10.22,27.423-.861,28.242V0Z",
    transform: "translate(0.861)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(253.64 -115.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M5.713,0V11.014c0,8.631-2.543,14.636-7.141,17.066C-1.439,27.2-1.5,22.813-1.51,22.6c2.251-2.13,3.261-5.738,3.261-11.689V0Z",
    transform: "translate(1.51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(284.552 -116.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M21.134,0c-.722,18.178-8.209,26.46-24.963,27.612V23.067c12.5-.677,19.154-6.628,20.322-18.2l.034-.344H3.562l-.081.184a14.837,14.837,0,0,1-9.066,8.057V8.192A11.806,11.806,0,0,0,.956,0Z",
    transform: "translate(5.585 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(317.803 -116.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M16.753,0V6.266C16.753,21.113,11,26.98-4.427,27.82V23.17C8.112,22.4,12.364,18.1,12.364,6.229V0Z",
    transform: "translate(4.427)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M118.222-114.856h-4.386v-16.182h4.386Z",
    transform: "translate(201.307 14.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M144.025-126.077H119.614v-4.756h24.411Z",
    transform: "translate(223.171 15.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M145.972-121.64H119.387v-4.854h26.585Z",
    transform: "translate(222.313 31.864)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g80",
    transform: "translate(374.463 -110.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M15.356,0c-.4,15.075-5.526,20.917-19.414,22.126V17.572C7.65,16.357,10.833,12.675,11.128,0Z",
    transform: "translate(4.058)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84",
    transform: "translate(372.029 -110.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M3.277,0C3.35.5,4.762,10.511,4.85,11.169H.631C.56,10.663-.777.657-.866,0Z",
    transform: "translate(0.866)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(379.705 -110.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M3.273,0c.071.5,1.455,10.511,1.543,11.169H.622C.554,10.663-.777.657-.865,0Z",
    transform: "translate(0.865)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92",
    transform: "translate(396.994 -116.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M21.13,0c-.716,18.178-8.209,26.46-24.963,27.612V23.067c12.5-.677,19.155-6.628,20.328-18.2l.03-.343H3.558l-.078.184a14.852,14.852,0,0,1-9.065,8.057V8.192A11.813,11.813,0,0,0,.956,0Z",
    transform: "translate(5.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96",
    transform: "translate(122.936 -101.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M13.95,0V13.223H11.319v-.646H-1.2v.646H-3.687V.022H-1.2V10.2H11.319V0Z",
    transform: "translate(3.687)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100",
    transform: "translate(126.045 -102.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M6.98,0c.307.1,1.637.537,1.971.646A14.608,14.608,0,0,1,7.774,2.9c-.062-.022-1.455-.569-1.813-.7A15.519,15.519,0,0,0,6.98,0M4.926.172V3.34H9.274V5.355H5.939l.425.383A11.263,11.263,0,0,0,9.313,7.78c-.186.321-.97,1.684-1.141,1.975A10.454,10.454,0,0,1,5.315,7.191l-.388-.464V9.866H2.607V6.751l-.385.435A14.107,14.107,0,0,1-.692,9.741C-.879,9.436-1.669,8.1-1.845,7.806A11.466,11.466,0,0,0,1.175,5.73l.4-.375H-1.7V3.34H2.607V.172H4.926",
    transform: "translate(1.845)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(122.05 -110.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M8.847,0V1.062h7.043V3.328H8.847V4.785h8.2V7.169H-2.338V4.785h2.25v-4H2.648v4H6.155V0Z",
    transform: "translate(2.338)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g108",
    transform: "translate(126.679 -102.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M1.41,0A13.057,13.057,0,0,1,2.419,2.042c-.321.1-1.576.537-1.877.638A12.633,12.633,0,0,0-.373.714C-.037.577,1.146.1,1.41,0",
    transform: "translate(0.373)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g112",
    transform: "translate(158.817 -93.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M.286,0A.36.36,0,0,0-.075.358.363.363,0,0,0,.286.717.363.363,0,0,0,.643.358.359.359,0,0,0,.286,0",
    transform: "translate(0.075)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g116",
    transform: "translate(151.75 -110.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M7.78,0V12.032l1.451-.309c.029.407.216,2.717.238,3.033-.3.061-1.689.365-1.689.365v6.359h-2.8v-5.76l-6.666,1.416c-.052-.39-.332-2.705-.371-3.033.371-.078,7.038-1.494,7.038-1.494V0ZM1.127.78A17.471,17.471,0,0,1,4.594,3.807L2.724,6.055A21.2,21.2,0,0,0-.5,2.864C-.291,2.6.916,1.056,1.127.78",
    transform: "translate(2.056)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "translate(143.237 -110.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M6.185,0c.1.321.807,2.393.928,2.746a20.758,20.758,0,0,1-2.427.52l-.179.025V6.037H6.672V8.788H4.507V9.2l.025.052a13.817,13.817,0,0,0,2.432,3.082c-.1.214-.95,2.089-1.217,2.656-.427-.775-.7-1.359-.805-1.6l-.435.047v8.15H2V13.834l-.422-.079a22.54,22.54,0,0,1-2.285,4.2c-.177-.731-.881-3.661-.928-3.856A15.225,15.225,0,0,0,1.584,9.087l.127-.3H-1.175V6.037H2V3.551l-2.486.11s-.186.008-.341.008c-.046-.307-.327-2.294-.38-2.68A28.073,28.073,0,0,0,6.185,0",
    transform: "translate(1.634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g124",
    transform: "translate(152.117 -103.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "M1.363,0A14.764,14.764,0,0,1,4.775,3.041c-.2.231-1.617,1.914-1.894,2.24A15.723,15.723,0,0,0-.36,2.1L1.363,0",
    transform: "translate(0.36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g128",
    transform: "matrix(1, -0.026, 0.026, 1, 60.636, -133.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M38.088,43.289c.328.232.538.367.538.367a14.5,14.5,0,0,0,7.85,2.281c3.72.143,5.78-3.644,6.108-6.927-2.787,3.857-8.427,3.628-11.8,2.7l1.133-.791c1.824-1.422,4.321-3.616,4.988-6.153.7-2.676-.365-5.482-2.435-6.379,0,0-3-1.426-5.726,2.51-2.384-3.777-5.515-2.6-5.515-2.6-2.082.772-3.349,3.469-2.893,6.144.377,2.189,3.748,5.485,5.878,7.34a14.556,14.556,0,0,1-1.885.414C17.012,44.61,8.287,34.59,6.672,23.935,4.986,12.817,13.345,4.224,19.481,3.074S32.026,5.632,32.026,5.632a13.078,13.078,0,0,1,7.09,13.242v.075a8.175,8.175,0,0,0,2.762-6.539C40.659,3.764,32.54,1.36,32.54,1.36A27.1,27.1,0,0,0,24.269,0,24.01,24.01,0,0,0,6.851,6.772,22.475,22.475,0,0,0,0,23.612a24.621,24.621,0,0,0,1.1,7.6,20.085,20.085,0,0,0,3.363,6.267A23.772,23.772,0,0,0,10.7,42.822a19.7,19.7,0,0,0,6.534,2.5,40.538,40.538,0,0,0,8.1.785A38.129,38.129,0,0,0,34.854,44.6a20.068,20.068,0,0,0,2.466-.94s.311-.138.768-.37M32.422,33.77c-.646-3.922,3.243-7.571,6.349-2.126,3.33-5.518,7.243-1.681,6.222,2.353-.485,1.925-2.295,3.659-3.874,4.952-.117.1-1.8,1.327-2.628,1.8-.656-.216-5.672-4.567-6.068-6.978",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoralLogo);
export default __webpack_public_path__ + "static/media/coral-logo.5dc1bdb9.svg";
export { ForwardRef as ReactComponent };